import { cn } from "@/lib/utils"

// Sweeping shimmer (a translucent band translating left-to-right across the
// block) rather than the shadcn default's flat animate-pulse opacity fade --
// requested explicitly so loading states read as "content is coming" instead
// of "something is stuck". bg-muted is the base fill; the ::after pseudo
// element carries the moving highlight band, clipped to the block's own
// rounded corners via overflow-hidden. white/10 (not /20) in dark mode since
// a bright sweep over the dark "ink" theme's muted tone reads as too strong
// otherwise.
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-muted",
        "after:absolute after:inset-0 after:-translate-x-full after:animate-shimmer",
        "after:bg-gradient-to-r after:from-transparent after:via-white/20 after:to-transparent",
        "dark:after:via-white/10",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
